import { IconType } from '@shared-features/enums/shared-enums.enum';
import { ColsWithBreakpoint } from '@shared/components/grid/col.component';
import { PageDirectionEnum } from '@shared/enums';

export class LabeledInfoItem {
  constructor(
    public label: string,
    public value: any,
    public cols?: ColsWithBreakpoint,
    public suffix?: string,
    public iconSize?: string,
    public iconType?: IconType,
    public icon?: string,
    public iconPosition?: PageDirectionEnum,
    public iconDirection?: PageDirectionEnum,
    public riyalValue?: boolean,
    public iconColor? :string
  ) {}
}
